import { z } from "zod";
import { ActionCommonParamsSchema } from "../../types";

export const ShipinhaoGetLocationParamsSchema = ActionCommonParamsSchema.extend({
    keyword: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    city: z.string().optional(),
    count: z.number().optional(),
});

export type ShipinhaoGetLocationParams = z.infer<typeof ShipinhaoGetLocationParamsSchema>;
